import { render } from "./index.vue?vue&type=template&id=01ffa3cc"
import script from "./third.js?vue&type=script&lang=js&external"
export * from "./third.js?vue&type=script&lang=js&external"

import "./third.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__